<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
};
</script>

<style lang="less">
@import url("./assets/css/index.less");

html,
body,
#app,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}

.head_search_row {
  display: flex;
  justify-content: space-between;
}

.order_info_row {
  display: flex;
  color: #666;
  margin-bottom: 8px;
}

.order_info_tit {
  min-width: fit-content;
  width: fit-content;
}

.order_info_detail {
  font-weight: bold;
  color: #333;
  margin-left: 4px;
}

.btn_row {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}
</style>
